import { useEffect, useState, useRef } from 'react';

const BACKEND = 'https://3amenu.com/api';

const sesCardir = () => {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.frequency.setValueAtTime(523, ctx.currentTime);
  osc.frequency.setValueAtTime(659, ctx.currentTime + 0.1);
  osc.frequency.setValueAtTime(784, ctx.currentTime + 0.2);
  gain.gain.setValueAtTime(0.4, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
  osc.start(ctx.currentTime);
  osc.stop(ctx.currentTime + 0.5);
};

function MutfakEkrani({ kullanici }) {
  const [siparisler, setSiparisler] = useState([]);
  const [tamamlananlar, setTamamlananlar] = useState([]);
  const [kafeAdi, setKafeAdi] = useState('');
  const [aktifSekme, setAktifSekme] = useState('bekleyen');
  const [sadeGorünüm, setSadeGorunum] = useState(false);
  const oncekiSiparisler = useRef([]);
  const cafeId = kullanici.uid;

  const siparisleriGetir = async () => {
    try {
      const [s, t, k] = await Promise.all([
        fetch(`${BACKEND}/siparisler/${cafeId}`).then(r => r.json()),
        fetch(`${BACKEND}/siparisler/tamamlanan/${cafeId}`).then(r => r.json()),
        fetch(`${BACKEND}/menu/kafe-by-id/${cafeId}`).then(r => r.json()),
      ]);

      const yeniSiparisler = Array.isArray(s) ? s : [];

      // Yeni sipariş geldiyse ses çal
      yeniSiparisler.forEach(siparis => {
        if (!oncekiSiparisler.current.find(x => x.id === siparis.id)) {
          sesCardir();
        }
      });
      oncekiSiparisler.current = yeniSiparisler;

      setSiparisler(yeniSiparisler);
      setTamamlananlar(Array.isArray(t) ? t.slice(0, 20) : []); // son 20
      if (k?.ad) setKafeAdi(k.ad);
    } catch (err) { console.error(err); }
  };

  const siparisiBitir = async (siparisId) => {
    try {
      await fetch(`${BACKEND}/siparisler/${siparisId}/tamamla`, { method: 'PATCH' });
      siparisleriGetir();
    } catch { alert('Hata!'); }
  };

  useEffect(() => {
    siparisleriGetir();
    const interval = setInterval(siparisleriGetir, 4000);
    return () => clearInterval(interval);
  }, []);

  // Siparişleri masa bazlı grupla
  const masaBazli = siparisler.reduce((acc, s) => {
    if (!acc[s.masaNo]) acc[s.masaNo] = { masaNo: s.masaNo, siparisler: [], olusturmaTarihi: s.olusturmaTarihi };
    acc[s.masaNo].siparisler.push(s);
    return acc;
  }, {});

  // Her masanın ürünlerini birleştir
  const masaListesi = Object.values(masaBazli).map(masa => {
    const urunler = {};
    masa.siparisler.forEach(s => {
      s.urunler.forEach(u => {
        if (!urunler[u.ad]) urunler[u.ad] = { ad: u.ad, adet: 0 };
        urunler[u.ad].adet += u.adet;
      });
    });
    return { ...masa, birlesikUrunler: Object.values(urunler) };
  });

  // Tamamlananları masa bazlı grupla (son 10 masa)
  const tamamlananMasalar = tamamlananlar.reduce((acc, s) => {
    if (!acc[s.masaNo]) acc[s.masaNo] = { masaNo: s.masaNo, siparisler: [] };
    acc[s.masaNo].siparisler.push(s);
    return acc;
  }, {});

  const simdi = new Date();
  const sure = (tarih) => {
    if (!tarih) return '';
    const t = tarih?.toDate ? tarih.toDate() : new Date(tarih._seconds ? tarih._seconds * 1000 : tarih);
    const fark = Math.floor((simdi - t) / 60000);
    if (fark < 1) return 'Az önce';
    return `${fark} dk önce`;
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <div className="bg-gray-800 px-6 py-4 flex justify-between items-center sticky top-0 z-10 border-b border-gray-700">
        <div className="flex items-center gap-3">
          <span className="text-2xl">👨‍🍳</span>
          <div>
            <h1 className="text-xl font-bold">Mutfak Ekranı</h1>
            {kafeAdi && <p className="text-xs text-gray-400">{kafeAdi}</p>}
          </div>
          {siparisler.length > 0 && (
            <span className="bg-orange-500 text-white text-sm font-bold px-3 py-1 rounded-full animate-pulse">
              {siparisler.length} bekleyen
            </span>
          )}
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => setSadeGorunum(p => !p)}
            className={`px-3 py-2 rounded-xl text-xs font-medium ${sadeGorünüm ? 'bg-orange-500 text-white' : 'bg-gray-700 text-gray-300'}`}>
            {sadeGorünüm ? '📋 Sade' : '📋 Normal'}
          </button>
          <div className="flex gap-2">
            <button onClick={() => setAktifSekme('bekleyen')}
              className={`px-4 py-2 rounded-xl text-sm font-medium ${aktifSekme === 'bekleyen' ? 'bg-orange-500 text-white' : 'bg-gray-700 text-gray-300'}`}>
              ⏳ Bekleyen {siparisler.length > 0 && `(${siparisler.length})`}
            </button>
            <button onClick={() => setAktifSekme('tamamlanan')}
              className={`px-4 py-2 rounded-xl text-sm font-medium ${aktifSekme === 'tamamlanan' ? 'bg-green-500 text-white' : 'bg-gray-700 text-gray-300'}`}>
              ✅ Tamamlanan
            </button>
          </div>
        </div>
      </div>

      <div className="p-6">
        {/* BEKLEYENLEr */}
        {aktifSekme === 'bekleyen' && (
          masaListesi.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-32 text-gray-500">
              <p className="text-6xl mb-4">✅</p>
              <p className="text-xl font-medium">Bekleyen sipariş yok</p>
              <p className="text-sm mt-2">Yeni siparişler otomatik gelecek</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {masaListesi.map(masa => (
                <div key={masa.masaNo}
                  className="bg-gray-800 rounded-2xl border-2 border-orange-500/50 overflow-hidden">
                  {/* Masa başlık */}
                  <div className="bg-orange-500 px-4 py-3 flex justify-between items-center">
                    <span className="font-bold text-xl">Masa {masa.masaNo}</span>
                    <span className="text-orange-100 text-xs font-medium">
                      {sure(masa.siparisler[0]?.olusturmaTarihi)}
                    </span>
                  </div>

                  {/* Ürünler */}
                  <div className="p-4">
                    {sadeGorünüm ? (
                      // Sade görünüm — sadece ürün adı ve adet
                      <div className="space-y-2">
                        {masa.birlesikUrunler.map((u, i) => (
                          <div key={i} className="flex items-center gap-3">
                            <span className="bg-orange-500 text-white font-bold text-lg w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0">
                              {u.adet}
                            </span>
                            <span className="font-semibold text-white text-base">{u.ad}</span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      // Normal görünüm — sipariş bazlı
                      masa.siparisler.map((siparis, si) => (
                        <div key={siparis.id} className={si > 0 ? 'mt-3 pt-3 border-t border-gray-700' : ''}>
                          {si > 0 && <p className="text-xs text-gray-500 mb-2">+ Ek sipariş</p>}
                          {siparis.urunler.map((u, i) => (
                            <div key={i} className="flex items-center gap-3 py-1.5">
                              <span className="bg-orange-500 text-white font-bold text-sm w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0">
                                {u.adet}
                              </span>
                              <span className="text-white font-medium">{u.ad}</span>
                            </div>
                          ))}
                        </div>
                      ))
                    )}
                  </div>

                  {/* Tamamla butonu */}
                  <div className="px-4 pb-4 flex gap-2">
                    {masa.siparisler.map((siparis, i) => (
                      <button key={siparis.id} onClick={() => siparisiBitir(siparis.id)}
                        className="flex-1 bg-green-500 hover:bg-green-400 text-white py-3 rounded-xl font-bold text-sm transition-all active:scale-95">
                        {masa.siparisler.length > 1 ? `✅ ${i + 1}. Hazır` : '✅ Hazır'}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )
        )}

        {/* TAMAMLANANLAR */}
        {aktifSekme === 'tamamlanan' && (
          Object.values(tamamlananMasalar).length === 0 ? (
            <div className="flex flex-col items-center justify-center py-32 text-gray-500">
              <p className="text-6xl mb-4">📋</p>
              <p className="text-xl font-medium">Henüz tamamlanan yok</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {Object.values(tamamlananMasalar).map(masa => (
                <div key={masa.masaNo} className="bg-gray-800 rounded-2xl border border-green-500/30 overflow-hidden opacity-75">
                  <div className="bg-green-700 px-4 py-3">
                    <span className="font-bold text-lg">✅ Masa {masa.masaNo}</span>
                  </div>
                  <div className="p-4">
                    {masa.siparisler.flatMap(s => s.urunler).map((u, i) => (
                      <div key={i} className="flex items-center gap-3 py-1">
                        <span className="bg-green-700 text-white font-bold text-sm w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0">{u.adet}</span>
                        <span className="text-gray-300 line-through">{u.ad}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default MutfakEkrani;